import script from "./UpgradePlanDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradePlanDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpgradePlanDialog.vue?vue&type=style&index=0&id=81eadb52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81eadb52"]])

export default __exports__